import { createAction, props } from '@ngrx/store';
import { ICommunity } from '../model/community.model';
import { ISearch } from '../model/search.model';
import { IUser } from '../../user/model/user.model';

export const createCommunity = createAction('[Communities] Create community request', (community: ICommunity) => ( community ));
export const createCommunitySuccess = createAction('[Communities] Community created successfully', props<{ community: ICommunity }>());
export const createCommunityFailure = createAction('[Communities] Community does not created', props<{ error: string }>());

export const editCommunity = createAction('[Communities] Edit community request', (community: ICommunity) => ( community ));
export const editCommunitySuccess = createAction('[Communities] Edit created successfully', props<{ community: ICommunity }>());
export const editCommunityFailure = createAction('[Communities] Edit does not created', props<{ error: string }>());

export const cancelRequestCommunity = createAction('[Communities] Cancel sending community request', (communityId: string) => ({ communityId }));
export const cancelRequestCommunitySentSuccess = createAction('[Communities] Cancel sending community request successfully', props<{ community: ICommunity }>());
export const cancelRequestCommunitySentFailure = createAction('[Communities] Cancel sending community request with errors', props<{ error: string }>());

export const getCommunities = createAction('[Communities] Get all communities');
export const getCommunitiesSuccess = createAction('[Communities] Get all communities success', props<{ communities: ICommunity[] }>());

export const deleteCommunity = createAction('[Communities] Delete community request', (communityId: string) => ({ communityId }));
export const deleteCommunitySentSuccess = createAction('[Communities] Delete community request successfully', props<{ community: ICommunity }>());
export const deleteCommunitySentFailure = createAction('[Communities] Delete community request with errors', props<{ error: string }>());

export const searchCommunity = createAction('[Communities] Search people request', props<{ searchCriteria: ISearch }>());
export const searchCommunitySentSuccess = createAction('[Communities] Search people sent successfully', props<{ searchResults: IUser[] }>());
export const searchCommunitySentFailure = createAction('[Communities] Search people sent with errors', props<{ error: string }>());

export const getPendingCommunity = createAction('[Communities] Get all pending community');
export const getPendingCommunitySuccess = createAction('[Communities] Get all pending community success', props<{ communities: ICommunity[] }>());

export const selectCommunity = createAction('[Communities] Select community', (communityId: string) => ({ communityId }));
export const unselectCommunity = createAction('[Communities] Unselect community', (communityId: string) => ({ communityId }));

export const communitiesActions = {
    createCommunity,
    createCommunitySuccess,
    createCommunityFailure,
    editCommunity,
    editCommunitySuccess,
    editCommunityFailure,
    getCommunities,
    getCommunitiesSuccess,
    cancelRequestCommunity,
    cancelRequestCommunitySentSuccess,
    cancelRequestCommunitySentFailure,
    deleteCommunity,
    deleteCommunitySentSuccess,
    deleteCommunitySentFailure,
    searchCommunity,
    searchCommunitySentSuccess,
    searchCommunitySentFailure,
    getPendingCommunity,
    getPendingCommunitySuccess,
    selectCommunity,
    unselectCommunity
}